import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const ZoomControl = ({
  zoomValue,
  onZoomIn,
  onZoomOut,
  onZoomReset,
  l // translations
}) => {
  return (
    <div className="zoom-control">
      <Button.Group size="small">
        <Button 
          icon
          onClick={onZoomOut}
          title={l.zoom_out}
        >
          <Icon name="zoom-out" />
        </Button>
        <Button 
          basic
          style={{ cursor: 'default' }}
        >
          {Math.round(zoomValue * 100)}%
        </Button>
        <Button 
          icon
          onClick={onZoomIn}
          title={l.zoom_in}
        >
          <Icon name="zoom-in" />
        </Button>
        <Button 
          icon
          onClick={onZoomReset}
          title={l.zoom_reset}
        >
          <Icon name="undo" />
        </Button>
      </Button.Group>
    </div>
  );
};

export default ZoomControl;
